export default __webpack_public_path__ + "static/media/Q09_願你每個假日時光，都有開心豐富體驗.803ecf96.mp4";